module.exports = __webpack_public_path__ + "static/media/awfxex32_117.ec7763be.ico";